import { JSX } from "react";
import { ReportFieldRights } from "core/blueprint/trajectory/TrajectoryBlueprintService";
import {
	BooleanField,
	DateField,
	DecimalField,
	Field,
	FieldType,
	GroupField,
	ImageField,
	IntegerField,
	MultiSelectField,
	RatingField,
	SelectField,
	TextField,
	UrlField
} from "../FieldService";
import BooleanInput from "./BooleanInput";
import DateInput from "./DateInput";
import DecimalInput from "./DecimalInput";
import GroupInput from "./GroupInput";
import ImageInput from "./ImageInput";
import IntegerInput from "./IntegerInput";
import MultiSelectInput from "./MultiSelectInput";
import RatingInput from "./RatingInput";
import SelectInput from "./SelectInput";
import TextInput from "./TextInput";
import UrlInput from "./UrlInput";
import UploadInput from "./UploadInput";

export type FieldInputProps = {
	labels: Map<string, Array<string>>;
	filter: Array<string>;
	field: Field;
	rights: ReportFieldRights;
	editable: boolean;
	onChange: (uuid: string, value: string) => void;
};

const FieldInput: React.FC<FieldInputProps> = (props: FieldInputProps) => {
	function getSpecializedField(): JSX.Element {
		switch (props.field.type) {
			case FieldType.BOOLEAN:
				return (
					<BooleanInput
						{...props}
						field={props.field as BooleanField}
					/>
				);
			case FieldType.DATE:
				return (
					<DateInput {...props} field={props.field as DateField} />
				);
			case FieldType.DECIMAL:
				return (
					<DecimalInput
						{...props}
						field={props.field as DecimalField}
					/>
				);
			case FieldType.GROUP:
				return (
					<GroupInput {...props} field={props.field as GroupField} />
				);
			case FieldType.IMAGE:
				return (
					<ImageInput {...props} field={props.field as ImageField} />
				);
			case FieldType.INTEGER:
				return (
					<IntegerInput
						{...props}
						field={props.field as IntegerField}
					/>
				);
			case FieldType.RATING:
				return (
					<RatingInput
						{...props}
						field={props.field as RatingField}
					/>
				);
			case FieldType.SELECT:
				return (
					<SelectInput
						{...props}
						field={props.field as SelectField}
					/>
				);
			case FieldType.MULTI_SELECT:
				return (
					<MultiSelectInput
						{...props}
						field={props.field as MultiSelectField}
					/>
				);
			case FieldType.TEXT:
				return (
					<TextInput {...props} field={props.field as TextField} />
				);
			case FieldType.URL:
				return <UrlInput {...props} field={props.field as UrlField} />;
			case FieldType.UPLOAD:
				return (
					<UploadInput {...props} field={props.field as ImageField} />
				);
			default:
				console.error("Uknown field type '" + props.field.type + "'");
				return <></>;
		}
	}

	return getSpecializedField();
};

export default FieldInput;
